/** Formats a price by adding commas and two digits after the decimal
 *
 * @param {number} price - the unformatted amount. Example: 1067.09
 * @returns {string} - the formatted amount. Example: 1,067.09
 */

export const formatPrice = (price: number): string => `${price.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',')}`;
